// extracted by mini-css-extract-plugin
export default {"container":"_2kDPJCd2xSKPBNwHFI3UOk","content":"_2unyrkZPsEZQm3pNM6COSZ","image":"_1yoaxIVgXtCfjYffoqIpsx","left":"_2qh1SIqCkLnhDWmVQ4UUdV","right":"_2zHWgbFimyRJwrpZ73ksHO"};